import React from 'react';
import { Alert, Skeleton, useToast } from '@razorpay/blade/components';
import { useFlexibleBenefitsWindowStatus } from './useFlexibleBenefitsWindowStatus';
import useIsFeatureDisabledForRearch from 'access/useIsFeatureDisabledForRearch';

interface FlexibleBenefitsCTAProps {
  userId: string;
  peopleOrgId: string;
  orgId: string;
  isFBPDisabled: boolean;
}

const FlexibleBenefitsCTA = ({ orgId, isFBPDisabled }: FlexibleBenefitsCTAProps) => {

  const toast = useToast();

  const { isMileStone1Enabled }= useIsFeatureDisabledForRearch()

  const { isLoading, isFBPSettingsEnabled, isDeclarationWindowOpen, isProofUploadWindowOpen } =
    useFlexibleBenefitsWindowStatus({
      orgId,
      isM3S2Enabled: isFBPDisabled,
      isFBPDisabled: isMileStone1Enabled,
      onError: () => {
        toast.show({
          content: 'Failed to load flexible benefits settings',
          color: 'negative',
        });
      },
    });

  if (isLoading) {
    return <Skeleton height="spacing.10" width="100%" />;
  }

  if( !isFBPSettingsEnabled){
    return null;
  }

  if (isDeclarationWindowOpen && isProofUploadWindowOpen) {
    return (
      <Alert
        color="information"
        isFullWidth
        marginY={'spacing.3'}
        isDismissible={false}
        description="Declaration and proof window are open. Please declare your investments and upload the proofs to get maximum tax benefits."
      />
    );
  }

  if (isDeclarationWindowOpen) {
    return (
      <Alert
        color="information"
        isDismissible={false}
        isFullWidth
        marginY={'spacing.3'}
        description="Declaration window is open. Please declare your investments to get maximum tax benefits."
      />
    );
  }

  if (isProofUploadWindowOpen) {
    return (
      <Alert
        color="information"
        isFullWidth
        marginY={'spacing.3'}
        isDismissible={false}
        description="Proof upload window is open. Please upload proof."
      />
    );
  }

  return null;
};

export { FlexibleBenefitsCTA };
